import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
// import { MetypeCommentingWidget } from "@metype/components";
import { object, number } from "prop-types";

import SupportQuint from "../support-quint";
import SocialShareLinks from "../../../molecules/social-share";
import AlsoWatch from "../../../molecules/also-watch";
import AlsoRead from "../../../rows/also-read";
import MoreFromFit from "../../../rows/more-from-fit";

import "./bottom-elements.m.css";

const BottomStoryElements = ({ story, wruData, showCommentWidget, index, merchantId, publisher }) => {
  const wruItem = wruData[story.id] || [];
  const showComment = showCommentWidget[story.id] || false;
  const item = wruItem.find((i) => i.category === "also_read_bottom");
  const items = (item && item.recommendations) || [];

  return (
    <div styleName="wrapper">
      <SupportQuint storyId={story.id} publisherName={publisher.name} />
      <SocialShare
        storyId={story.id}
        template={SocialShareLinks}
        title={story.headline}
        url={story.slug}
        color="#fff"
      />
      <MoreFromFit story={story} publisherName={publisher.name} />
      <AlsoWatch index={index} />
      <div styleName="also-read-bottom">
        <AlsoRead publisherName={publisher.name} list={items} merchantId={merchantId} name="Also Read Bottom" />
      </div>

      <div styleName="metype" style={{ display: showComment ? "block" : "none" }}>
        <p styleName="fallback-text">Loading Comments...</p>
        <div
          id={`metype-comment-widget-${story.id}`}
          data-metype-account-id={publisher.metype_account_id}
          data-metype-host={publisher.metype_url}
          data-metype-primary-color="#0987d5"
          data-metype-bg-color="#ffffff"
          data-metype-font-color="#4a4a4a"
          data-metype-comment-widget-id={story.id}
        />
      </div>
    </div>
  );
};

BottomStoryElements.propTypes = {
  story: object,
  wruData: object,
  index: number,
  merchantId: number,
  publisher: object,
  showCommentWidget: object,
};

const mapStateToProps = (state) => {
  return {
    wruData: get(state, ["storyReducer", "wruData"], {}),
    showCommentWidget: get(state, ["storyReducer", "showCommentWidget"], {}),
    merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
    publisher: get(state, ["qt", "config", "publisher-attributes"], {}),
  };
};

export default connect(mapStateToProps, null)(BottomStoryElements);
